module.exports = __webpack_public_path__ + "img/barSquareChart.35706060.svg";